import {
  DELETEWALLETOWNER_SUCCESS,
  DELETEWALLETOWNER_FAILED,
  RESET_DELETEWALLETOWNER,
  LOADING_DELETEWALLETOWNER,
  NETWORK_ERROR_DELETEWALLETOWNER,
} from "../types/index";

const initialState = {
  isLoading: false,
  success: false,
  network: false,
  failed: false,
  data: {},
  message: "",
  networkError: "",
};

export default (state = initialState, action) => {
  switch (action.type) {
    case LOADING_DELETEWALLETOWNER:
      return {
        ...state,
        isLoading: true,
        success: false,
        failed: false,
        network: false,
        data: {},
        message: "",
        networkError: "",
      };
    case DELETEWALLETOWNER_FAILED:
      return {
        ...state,
        isLoading: false,
        success: false,
        failed: true,
        network: false,
        data: action.payload,
        message: "",
        networkError: "",
      };
    case DELETEWALLETOWNER_SUCCESS:
      return {
        ...state,
        isLoading: false,
        success: true,
        failed: false,
        network: false,
        data: action.payload,
        message: "",
        networkError: "",
      };
    case NETWORK_ERROR_DELETEWALLETOWNER:
      return {
        ...state,
        isLoading: false,
        success: false,
        failed: false,
        network: true,
        data: {},
        message: "",
        networkError: "",
      };
    case RESET_DELETEWALLETOWNER:
      return (state = initialState);
    default:
      return state;
  }
};
